module.exports = __webpack_public_path__ + "static/img/frack5.c03161c8.png";